import { DISPATCHER_CHIPS } from '@/entities/chat'

export function QuickReplyChips({ onSend, disabled }: { onSend: (text: string) => void; disabled?: boolean }) {
  return (
    <div className="flex flex-wrap gap-1.5 px-3 pb-1.5">
      {DISPATCHER_CHIPS.map((chip) => (
        <button
          key={chip}
          type="button"
          disabled={disabled}
          onClick={() => onSend(chip)}
          className="h-7 rounded-full border border-line px-2.5 text-[12.5px] font-medium text-ink-2 transition-colors hover:bg-hover disabled:opacity-50"
        >
          {chip}
        </button>
      ))}
    </div>
  )
}
